import { render, staticRenderFns } from "./CreateAccount.vue?vue&type=template&id=4e835824&scoped=true&"
import script from "./CreateAccount.vue?vue&type=script&lang=js&"
export * from "./CreateAccount.vue?vue&type=script&lang=js&"
import style0 from "./CreateAccount.vue?vue&type=style&index=0&id=4e835824&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e835824",
  null
  
)

component.options.__file = "CreateAccount.vue"
export default component.exports